// src/pages/CancellationPolicy.js
import './CancellationPolicy.css';

export default function CancellationPolicy() {
  return (
    <div className="cancellation-container">
      <h1 className="cancellation-heading">Cancellation and Refund Policy</h1>

      <section className="cancellation-section">
        <h2 className="cancellation-subheading">Order Cancellation</h2>
        <p>
          Once an order is placed and confirmed, it enters our production process immediately to ensure timely delivery.
          As such, we do not support cancellation once the order is confirmed and payment is completed.
        </p>
      </section>

      <section className="cancellation-section">
        <h2 className="cancellation-subheading">Refunds</h2>
        <p>
          Since our products are customized and printed as per user input, we are unable to offer refunds unless there’s a proven defect or error caused during printing or delivery.
        </p>
      </section>

      <section className="cancellation-section">
        <h2 className="cancellation-subheading">Replacement</h2>
        <p>
          If you receive a damaged or incorrect item, please contact us within 48 hours of receiving your order. Include your order number and photos of the issue. We’ll investigate and, if valid, replace the product at no additional cost.
        </p>
      </section>

      <section className="cancellation-section">
        <h2 className="cancellation-subheading">Contact Us</h2>
        <p>
          For any issues related to cancellation, refunds, or replacements, reach us at:
        </p>
        <p>
          <strong>Email:</strong>{' '}
          <a href="mailto:info@weprintphotobooks.com">info@weprintphotobooks.com</a>
        </p>
        <p>
          <strong>Phone:</strong>{' '}
          <a href="tel:+918861494444">+91 88614 94444</a>
        </p>
      </section>
    </div>
  );
}
